<template>
  <b-modal
    size="lg"
    :visible="showModal"
    title="Add new customer:"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <!--Step 1-->
        <div v-if="step === 1" key="step1">
          <b-row>
            <b-col>
              <h5 class="text-center">
                <span class="text-info">{{
                  $t("globals.customer_information")
                }}</span>
                - {{ $t("globals.billing_information") }} -
                {{ $t("globals.shipping_information") }}
              </h5>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <h5 class="text-info">{{ $t("globals.company") }}</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                v-model="customer.customer_settings.invoice_imeis"
                :value="true"
                :unchecked-value="false"
              >
                Imeis on invoice
              </b-form-checkbox>
              <b-form-checkbox
                v-model="customer.customer_settings.is_whitelabel"
                :value="true"
                :unchecked-value="false"
              >
                Whitelabel
              </b-form-checkbox>
              <b-form-checkbox
                v-model="customer.customer_settings.is_keurmerk"
                :value="true"
                :unchecked-value="false"
              >
                Keurmerk
              </b-form-checkbox>
              <b-form-checkbox
                v-model="customer.customer_settings.parking"
                :value="true"
                :unchecked-value="false"
              >
                Parking
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox
                v-model="customer.customer_settings.web_app"
                :value="true"
                :unchecked-value="false"
              >
                Web App
              </b-form-checkbox>
              <b-form-checkbox
                v-model="customer.customer_settings.driver_id"
                :value="true"
                :unchecked-value="false"
              >
                DriverID
              </b-form-checkbox>
              <b-form-checkbox
                v-model="customer.customer_settings.live_driver_id"
                :value="true"
                :unchecked-value="false"
              >
                Live DriverID
              </b-form-checkbox>
              <b-form-checkbox
                v-model="customer.customer_settings.sms"
                :value="true"
                :unchecked-value="false"
              >
                SMS
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox
                v-model="customer.customer_settings.api"
                :value="true"
                :unchecked-value="false"
              >
                API
              </b-form-checkbox>
              <b-form-checkbox
                v-model="customer.customer_settings.iframe_page"
                :value="true"
                :unchecked-value="false"
              >
                iFrame page
              </b-form-checkbox>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <span>{{ $t("globals.category") }}:</span>
              <b-form-select
                :state="present(customer.category)"
                v-model="customer.category"
                :options="categoryOptions"
              />
            </b-col>
            <b-col>
              <span>{{ $t("globals.source") }}:</span>
              <b-form-select
                :state="present(customer.source)"
                v-model="customer.source"
                :options="sourceOptions"
              />
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <span>{{ $t("globals.name_type") }}:</span>
              <span
                v-if="customer.company_name.length == 0"
                class="text-danger float-right"
                >{{ $t("globals.empty") }}</span
              >
              <span v-else-if="!validName" class="text-danger float-right">{{
                $t("globals.name_already_exists")
              }}</span>
              <b-input-group>
                <b-form-input
                  v-model="customer.company_name"
                  :state="validName"
                />
                <b-form-select
                  style="max-width: 120px;"
                  v-model="customer.customer_settings.company_type"
                  :options="getCustomerSettingsCompanyTypeOptions"
                />
              </b-input-group>
              <span>{{ $t("globals.vat") }}:</span>
              <span class="float-right">{{ $t("globals.po_number") }}:</span>
              <b-input-group>
                <b-form-input v-model="customer.company_vat" />
                <b-form-input v-model="customer.company_po" />
              </b-input-group>
              <span>{{ $t("globals.country") + " A2 (ISO)" }}:</span>
              <b-form-input
                v-model="customer.company_country"
                :disabled="!(getUserSystem == 'ULU' || getUserSystem == 'iMoto')"
                :state="customer.company_country.length == 2"
              />
            </b-col>
            <b-col>
              <span>{{ $t("globals.address") }}:</span>
              <b-form-input v-model="customer.company_address" />
              <span>{{ $t("globals.city") }}:</span>
              <b-form-input v-model="customer.company_city" />
              <span>{{ $t("globals.postal_code") }}:</span>
              <b-form-input v-model="customer.company_postal_code" />
            </b-col>
          </b-row>
          <hr />
          <h5 class="text-info">{{ $t("globals.contact") }}</h5>
          <b-row>
            <b-col>
              <span>{{ $t("globals.first_name") }}:</span>
              <b-form-input
                v-model="customer.contact_first_name"
                :state="customer.contact_first_name.length > 0"
              />
              <span>{{ $t("globals.last_name") }}:</span>
              <b-form-input
                v-model="customer.contact_last_name"
                :state="customer.contact_last_name.length > 0"
              />
              <span>{{ $t("globals.email") }}:</span>
              <b-form-input
                v-model="customer.contact_email"
                :state="customer.contact_email.length > 0"
              />
              <span>{{ $t("globals.phone") }}:</span>
              <b-form-input v-model="customer.contact_phone" />
            </b-col>
            <b-col>
              <span>{{ $t("globals.address") }}:</span>
              <b-form-input v-model="customer.contact_address" />
              <span>{{ $t("globals.city") }}:</span>
              <b-form-input v-model="customer.contact_city" />
              <span>{{ $t("globals.postal_code") }}:</span>
              <b-form-input v-model="customer.contact_postal_code" />
              <span>{{ $t("globals.country") }}:</span>
              <b-form-input v-model="customer.contact_country" disabled />
            </b-col>
          </b-row>
          <hr />
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="toStep2()"
            variant="info"
          >
            {{ $t("globals.next") }}
          </b-btn>
          <b-btn
            style="float: right; margin: 0.3em;"
            @click="saveNewCustomer"
            variant="success"
            :disabled="!hasRequired"
          >
            {{ $t("globals.save") }}
          </b-btn>
          <b-btn
            style="float: left; margin: 0.3em;"
            @click="cancel()"
            variant="warning"
          >
            {{ $t("globals.cancel") }}
          </b-btn>
        </div>
        <!--Step 2-->
        <div v-else-if="step === 2" key="step2">
          <b-row>
            <b-col>
              <h5 class="text-center">
                {{ $t("globals.customer_information") }} -
                <span class="text-info">{{
                  $t("globals.billing_information")
                }}</span>
                - {{ $t("globals.shipping_information") }}
              </h5>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <span>{{ $t("globals.first_name") }}:</span>
              <b-form-input v-model="customer.billing_first_name" />
              <span>{{ $t("globals.last_name") }}:</span>
              <b-form-input v-model="customer.billing_last_name" />
              <span>{{ $t("globals.email") }}:</span>
              <b-form-input v-model="customer.billing_email" />
              <span>{{ $t("globals.phone") }}:</span>
              <b-form-input v-model="customer.billing_phone" />
            </b-col>
            <b-col>
              <span>{{ $t("globals.address") }}:</span>
              <b-form-input v-model="customer.billing_address" />
              <span>{{ $t("globals.city") }}:</span>
              <b-form-input v-model="customer.billing_city" />
              <span>{{ $t("globals.postal_code") }}:</span>
              <b-form-input v-model="customer.billing_postal_code" />
              <span>{{ $t("globals.country") }}:</span>
              <b-form-input v-model="customer.billing_country" disabled />
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <b-btn
                style="float: right; margin: 0.3em;"
                @click="toStep3()"
                variant="info"
              >
                {{ $t("globals.next") }}
              </b-btn>
              <b-btn
                style="float: right; margin: 0.3em;"
                @click="step = 1"
                variant="info"
              >
                {{ $t("globals.back") }}
              </b-btn>
              <b-btn
                style="float: left; margin: 0.3em;"
                @click="cancel()"
                variant="warning"
              >
                {{ $t("globals.cancel") }}
              </b-btn>
            </b-col>
          </b-row>
        </div>
        <!--Step 3-->
        <div v-else-if="step === 3" key="step3">
          <b-row>
            <b-col>
              <h5 class="text-center">
                {{ $t("globals.customer_information") }} -
                {{ $t("globals.billing_information") }} -
                <span class="text-info">{{
                  $t("globals.shipping_information")
                }}</span>
              </h5>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <span>{{ $t("globals.first_name") }}:</span>
              <b-form-input v-model="customer.shipping_first_name" />
              <span>{{ $t("globals.last_name") }}:</span>
              <b-form-input v-model="customer.shipping_last_name" />
              <span>{{ $t("globals.email") }}:</span>
              <b-form-input v-model="customer.shipping_email" />
              <span>{{ $t("globals.phone") }}:</span>
              <b-form-input v-model="customer.shipping_phone" />
            </b-col>
            <b-col>
              <span>{{ $t("globals.address") }}:</span>
              <b-form-input v-model="customer.shipping_address" />
              <span>{{ $t("globals.city") }}:</span>
              <b-form-input v-model="customer.shipping_city" />
              <span>{{ $t("globals.postal_code") }}:</span>
              <b-form-input v-model="customer.shipping_postal_code" />
              <span>{{ $t("globals.country") }}:</span>
              <b-form-input v-model="customer.shipping_country" disabled />
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <b-btn
                style="float: right; margin: 0.3em;"
                @click="saveNewCustomer"
                :disabled="!hasRequired"
                variant="success"
              >
                {{ $t("globals.save") }}
              </b-btn>
              <b-btn
                style="float: right; margin: 0.3em;"
                @click="step = 2"
                variant="info"
              >
                {{ $t("globals.back") }}
              </b-btn>
              <b-btn
                style="float: left; margin: 0.3em;"
                @click="cancel()"
                variant="warning"
              >
                {{ $t("globals.cancel") }}
              </b-btn>
            </b-col>
          </b-row>
        </div>
      </transition>
    </div>
  </b-modal>
</template>

<script>
import Customer from "@/models/customer/customer";
import CustomerInput from "@/models/customer/customer_input";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  props: {
    setNewCustomer: Function
  },
  data() {
    return {
      step: 1,
      validName: false,
      customer: new Customer(),
      sourceOptions: [],
      categoryOptions: []
    };
  },
  methods: {
    ...mapMutations(["setShowLoadingModal", "setShowNewCustomerModal"]),
    ...mapActions("customers", ["checkForExistingCustomerName"]),
    ...mapActions("axios_mod", ["mutationReturnData", "simpleFetch"]),
    ...mapActions("constants", ["fetchActiveEnums"]),
    saveNewCustomer() {
      let data = {
        query: `
          mutation CustomerCreateEdit ($customer: CustomerInput) {
            CustomerCreateEdit (customer: $customer) { company_name, id, company_country }
          }
        `,
        variables: {
          customer: new CustomerInput(this.customer)
        }
      };

      this.setShowLoadingModal(true);
      this.mutationReturnData({data, this_ref: this}).then((res) => {
        if (res) {
          this.setNewCustomer(
            res.CustomerCreateEdit.id,
            res.CustomerCreateEdit.company_name,
            res.CustomerCreateEdit.company_country
          );
          this.cancel();
        }
      }).finally(()=>{
        this.setShowLoadingModal(false)
      });
    },
    cancel() {
      this.closeModal();
      this.clearModalData();
    },
    toStep2() {
      this.step = 2;
    },
    toStep3() {
      this.step = 3;
    },
    closeModal() {
      this.setShowNewCustomerModal(false);
      this.step = 1;
    },
    clearModalData() {
      this.customer = new Customer();
    },
    checkValidName(name) {
      this.checkForExistingCustomerName(name)
        .then(res => {
          this.validName = !res.data.data.CustomerCheckExistingName;
        })
        .finally(() => {
          if (this.customer.company_name.length == 0) this.validName = false;
        });
    },
    callFetchEnums() {
      this.fetchActiveEnums({this_ref: this, enums: ["customer_category", "customer_source"]})
        .then((res) => {
          if (res) {
            this.categoryOptions = res.customer_category;
            this.sourceOptions = res.customer_source;
          }
        })
    },
    present(val) {
      return val != null && val.length > 0
    }
  },
  computed: {
    ...mapGetters("constants", ["getCustomerSettingsCompanyTypeOptions"]),
    ...mapGetters({
      showModal: "getShowNewCustomerModal",
      getUserSystem: "getUserSystem"
    }),
    hasRequired() {
      return (
        this.validName &&
        this.customer.source.length > 0 &&
        this.customer.category.length > 0 &&
        this.customer.company_country.length == 2 &&
        this.customer.contact_first_name.length > 0 &&
        this.customer.contact_last_name.length > 0 &&
        this.customer.contact_email.length > 0
      );
    }
  },
  watch: {
    "customer.company_name": function(newName) {
      this.validName = false;
      this.checkValidName(newName);
    },
    "customer.company_address": function(newAddress) {
      this.customer.contact_address = newAddress;
      this.customer.shipping_address = newAddress;
      this.customer.billing_address = newAddress;
    },
    "customer.company_city": function(newCity) {
      this.customer.contact_city = newCity;
      this.customer.shipping_city = newCity;
      this.customer.billing_city = newCity;
    },
    "customer.company_postal_code": function(newPostal) {
      this.customer.contact_postal_code = newPostal;
      this.customer.shipping_postal_code = newPostal;
      this.customer.billing_postal_code = newPostal;
    },
    "customer.company_country": function(newCountry) {
      this.customer.contact_country = newCountry;
      this.customer.shipping_country = newCountry;
      this.customer.billing_country = newCountry;
    },
    "customer.contact_first_name": function(newName) {
      this.customer.shipping_first_name = newName;
      this.customer.billing_first_name = newName;
    },
    "customer.contact_last_name": function(newSurname) {
      this.customer.shipping_last_name = newSurname;
      this.customer.billing_last_name = newSurname;
    },
    "customer.contact_email": function(newEmail) {
      this.customer.shipping_email = newEmail;
      this.customer.billing_email = newEmail;
    },
    "customer.contact_phone": function(newPhone) {
      this.customer.shipping_phone = newPhone;
      this.customer.billing_phone = newPhone;
    }
  },
  mounted() {
    this.callFetchEnums();

    if (this.getUserSystem == "Fleetify" || this.getUserSystem == "uluuk") {
      this.customer.company_country = "UK";
    } else {
      this.customer.company_country = "NL";
    }
  }
};
</script>

<style scoped>
#selCustomerRow {
  margin-top: 20px;
}

.fade-enter-active {
  animation: fade-in 0.2s ease-out forwards;
}

.fade-leave-active {
  animation: fade-out 0.2s ease-out forwards;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>
